import styled from "styled-components";

export const CallAttempt = styled.span`
  color: ${props => props.theme.colors.accent};
  display: flex;
  align-items: center;
  gap: .5rem;
`;
